import React from 'react';
import NavigationBar from '../NavigationBar/NavigationBar';
import logo from '../../assets/images/LOGO-2.png';

class PageHeader extends React.Component{
  render(){
    return (
      <div className="page-header">
        <div className='header-image-container'>
          <div className='shadow'></div>
          <div className='header-image-wrap'>
            <img src={logo} alt='logo'/>
          </div>
        </div>
        <NavigationBar i18n={this.props.i18n} t={this.props.t} changeLanguage={this.props.changeLanguage}/>
      </div>
    )
  }
}

export default PageHeader;
